import { render } from "./UsersTabMenu.vue?vue&type=template&id=481d10c6&scoped=true"
import script from "./UsersTabMenu.vue?vue&type=script&lang=js"
export * from "./UsersTabMenu.vue?vue&type=script&lang=js"

import "./UsersTabMenu.vue?vue&type=style&index=0&id=481d10c6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481d10c6"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QList,QItem,QItemSection,QCheckbox,QItemLabel,QChip,QInnerLoading});
